/**
 * useVideoEffects — CSS filters only, zero canvas overhead
 */

import { useCallback, useState } from "react";

export const FILTERS = [
  { id: "none", label: "Normal", css: "none" },
  { id: "bright", label: "Brighten", css: "brightness(1.15) contrast(1.05)" },
  {
    id: "cinematic",
    label: "Cinematic",
    css: "contrast(1.1) saturate(0.85) sepia(0.1)",
  },
  { id: "grayscale", label: "Grayscale", css: "grayscale(1)" },
  {
    id: "warm",
    label: "Warm",
    css: "saturate(1.2) sepia(0.2) brightness(1.05)",
  },
  {
    id: "cool",
    label: "Cool",
    css: "saturate(0.85) hue-rotate(20deg) brightness(1.05)",
  },
];

export const useVideoEffects = () => {
  const [activeFilterId, setActiveFilterId] = useState("none");

  const applyFilter = useCallback((filter) => {
    window.dispatchEvent(
      new CustomEvent("bizro:videoFilter", { detail: { css: filter.css } }),
    );
    setActiveFilterId(filter.id);
  }, []);

  const applyNone = useCallback(() => {
    applyFilter(FILTERS[0]);
  }, [applyFilter]);

  return {
    activeFilterId,
    applyFilter,
    applyNone,
    FILTERS,
  };
};
